import { Component, computed, input } from '@angular/core';
import { lucideChevronRight } from '@ng-icons/lucide';
import { hlm } from '@spartan-ng/helm/utils';
import { HlmIconComponent, provideIcons } from '@spartan-ng/ui-icon-helm';
import type { ClassValue } from 'clsx';

@Component({
  selector: 'hlm-menu-item-sub-indicator',
  standalone: true,
  providers: [provideIcons({ lucideChevronRight })],
  imports: [HlmIconComponent],
  template: `<hlm-icon size="none" [userClass]="'w-full h-full'" name="lucideChevronRight"></hlm-icon>`,
  host: {
    '[class]': '_computedClass()',
  },
})
export class HlmMenuItemSubIndicatorComponent {
  public readonly userClass = input<ClassValue>('');
  protected _computedClass = computed(() => hlm('inline-block ml-auto h-4 w-4', this.userClass()));
}
